import React from 'react';
import { EntityCard, EntityCardGrid } from '../../../shared/components/patterns';
import { resolvePrimaryClientContact } from '../utils/clientContacts.helpers';

function getInitials(value = '') {
  return value
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

function getClientEmail(client) {
  return resolvePrimaryClientContact(client, 'email');
}

function getClientPhone(client) {
  return resolvePrimaryClientContact(client, 'phone');
}

function renderClientCard(client, { onSelect, onEdit, onArchive, onDelete }) {
  const email = getClientEmail(client);
  const phone = getClientPhone(client);
  const archived = Boolean(client.archived);

  return (
    <EntityCard
      key={client.id}
      title={client.name}
      subtitle={client.company}
      initials={getInitials(client.name || client.company)}
      status={{
        label: archived ? 'Disattivato' : 'Attivo',
        tone: archived ? 'neutral' : 'approved',
      }}
      meta={[
        { label: 'Email', value: email },
        { label: 'Telefono', value: phone },
        { label: 'C.F.', value: client.codiceFiscale || 'N/A' },
        { label: 'Riferito', value: client.referredBy || 'N/D' },
      ]}
      actions={[
        {
          id: 'edit',
          label: 'Modifica cliente',
          iconKey: 'actions.edit',
          onClick: () => onEdit?.(client),
        },
        {
          id: 'delete',
          label: archived ? 'Riattiva cliente' : 'Disattiva cliente',
          iconKey: archived ? 'actions.reset' : 'actions.delete',
          tone: archived ? 'default' : 'danger',
          onClick: () => onArchive?.(client),
        },
        archived ? {
          id: 'delete-permanently',
          label: 'Elimina definitivamente cliente',
          iconKey: 'actions.delete',
          tone: 'danger',
          onClick: () => onDelete?.(client),
        } : null,
      ].filter(Boolean)}
      onClick={() => onSelect?.(client)}
    />
  );
}

function ClientsTable({ data, onSelect, onEdit, onArchive, onDelete }) {
  if (!data.length) {
    return <EntityCardGrid emptyState="Nessun cliente trovato." />;
  }

  const activeClients = data.filter((client) => !client.archived);
  const archivedClients = data.filter((client) => client.archived);

  const renderSection = (title, clients) => (
    <section className="clients-list-section" key={title}>
      <div className="clients-list-section-header">
        <h2>{title}</h2>
        <span>{clients.length}</span>
      </div>
      <EntityCardGrid>
        {clients.map((client) => renderClientCard(client, { onSelect, onEdit, onArchive, onDelete }))}
      </EntityCardGrid>
    </section>
  );

  return (
    <div className="clients-list-sections">
      {renderSection('Attivi', activeClients)}
      {archivedClients.length > 0 ? renderSection('Disattivati', archivedClients) : null}
    </div>
  );
}

export default ClientsTable;
